
import {
  Component, Emit, Prop, Vue, Watch,
} from 'nuxt-property-decorator'
import type { Parser, HtmlRenderer } from 'commonmark'
import BaseLink from '../base/BaseLink.vue'
import type { TGptRole } from '../../shared/general/types/GptHub'

@Component({
  name: 'GptMessage',
  components: {
    BaseLink,
  },
})
export default class GptMessage extends Vue {
  @Prop({ required: true }) role! : TGptRole

  @Prop({ required: true }) content! : string

  @Prop({ default: false }) failed! : boolean

  private formattedContent : string = ''

  private parser ?: Parser

  private renderer ?: HtmlRenderer

  @Watch('content', { immediate: true })
  private async formatContent () {
    if (!this.content || this.role === 'user') return

    if (!this.parser || !this.renderer) {
      const commonmark = await import('commonmark')
      this.parser = new commonmark.Parser()
      this.renderer = new commonmark.HtmlRenderer({ safe: true })
    }

    const node = this.parser.parse(this.content)
    this.formattedContent = this.renderer.render(node)
  }

  @Emit('resend')
  private resend () : void {}
}
